import React, { useState, useRef } from "react";
import { updateServico } from "../../../services/ServicoService";
import { toast } from "react-toastify";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

export const EditarServicoModal = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const inputPrice = useRef("");
  const inputName = useRef("");

  function handleSubmit(e) {
    setLoading(true);
    e.preventDefault();

    // Monta o payload preservando os dados anteriores que não estão na UI
    const data = {
      id: props.service.id,
      companyDocumentNumber: localStorage.getItem("companyDocumentNumber"),
      price: parseFloat(inputPrice.current.value || 0),
      name: inputName.current.value,
      estimatedDays: props.service.estimatedDays || 0,
      estimatedMinutes: props.service.estimatedMinutes || 0,
      cost: props.service.cost || 0, // Mantém o custo anterior sem quebrar a API
    };

    updateServico(data)
      .then((response) => {
        props.listServicos(false);
        setIsOpen(false);
        toast.success(response || "Serviço atualizado com sucesso!");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 422) {
          toast.warn(error.response.data);
        } else {
          toast.error("Não foi possível editar este serviço");
        }
      });
  }

  return (
    <div>
      {/* Gatilho com ícone elegante no Dropdown de 3 pontos */}
      <button
        onClick={() => setIsOpen(true)}
        type="button"
        className="dropdown-item py-2 d-flex align-items-center"
      >
        <i className="fas fa-edit me-2 text-muted"></i>
        Editar
      </button>

      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        backdrop="static"
        size="lg"
        centered
      >
        {/* Cabeçalho corrigido de alta fidelidade com wrapTag="div" */}
        <ModalHeader 
          toggle={toggle} 
          wrapTag="div" 
          className="border-0 pb-0 pt-4 px-4 d-flex align-items-start"
        >
          <h5 className="fw-bold text-dark mb-0">Editar Serviço</h5>
          <p className="text-muted small mb-0 mt-1">Atualize rapidamente as informações do serviço</p>
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody className="px-4 pt-3 pb-4">
            
            {/* SEÇÃO ÚNICA: DADOS DO SERVIÇO (CARD LIGHT) */}
            <div className="bg-light p-3 rounded-4 border mb-2">
              <div className="d-flex align-items-center mb-3 text-primary">
                <i className="fas fa-tags me-2"></i>
                <span className="fw-bold text-muted small text-uppercase" style={{ fontSize: '0.72rem' }}>
                  Informações de Venda
                </span>
              </div>

              <div className="row g-3">
                {/* Nome do Serviço */}
                <div className="col-lg-8 col-md-12">
                  <label htmlFor="serviceName" className="form-label small fw-bold text-dark mb-2">
                    Nome do Serviço
                  </label>
                  <input
                    ref={inputName}
                    defaultValue={props.service.name}
                    type="text"
                    id="serviceName"
                    placeholder="Ex: Lavagem Simples"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    required
                    autoFocus
                  />
                </div>

                {/* Preço de Venda */}
                <div className="col-lg-4 col-md-12">
                  <label htmlFor="preco" className="form-label small fw-bold text-dark mb-2">
                    Preço (R$)
                  </label>
                  <input
                    ref={inputPrice}
                    defaultValue={props.service.price}
                    type="number"
                    inputMode="decimal"
                    step={0.01}
                    id="preco"
                    className="form-control form-control-lg fs-6 rounded-3 border-2 fw-bold text-primary"
                    required
                  />
                </div>
              </div>
            </div>

          </ModalBody>

          {/* Rodapé no Padrão Alcon (Sem botão vermelho) */}
          <ModalFooter className="border-0 pt-2 px-4 pb-4">
            {!loading ? (
              <div className="d-flex flex-column flex-sm-row w-100 gap-2 justify-content-sm-end">
                <button
                  type="button"
                  onClick={() => setIsOpen(false)}
                  className="btn btn-outline-secondary btn-lg fw-bold rounded-3 px-4 order-1 order-sm-0"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn btn-primary btn-lg fw-bold rounded-3 shadow-sm px-4"
                  style={{ minWidth: '160px' }}
                >
                  <i className="fas fa-save me-2"></i>
                  Salvar
                </button>
              </div>
            ) : (
              <div className="w-100 text-center py-2">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Salvando...</span>
                </div>
              </div>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
};

export default EditarServicoModal;